const vehicleCategoriesProps = [
	{
    number: 1,
		label: 'Bicicleta',
		category: 'bike',
		loadHeight: 30,
		loadWidth: 30,
		loadDepth: 40
	},
	{
    number: 2,
		label: 'Motoboy (baú)',
		category: 'motorcycle',
		loadHeight: 30,
		loadWidth: 30,
		loadDepth: 40
	},
	{
    number: 3,
		label: 'Automóvel (porta-malas)',
		category: 'car',
		loadHeight: 50,
		loadWidth: 80,
		loadDepth: 50
	},
	{
    number: 4,
		label: 'Van Pequena',
		category: 'smallVan',
		loadHeight: 100,
		loadWidth: 100,
		loadDepth: 140
	},
	{
    number: 5,
		label: 'Van Grande',
		category: 'bigVan',
		loadHeight: 100,
		loadWidth: 100,
		loadDepth: 140
	},
	{
    number: 6,
		label: 'Caminhão',
		category: 'truck',
		loadHeight: 100,
		loadWidth: 100,
		loadDepth: 140
	},
];

export default vehicleCategoriesProps;